import { gql } from "graphql-request"

const litecoin = {
    name: 'litecoin',
    title: 'Litecoin',
    currency: 'LTC',
    check: true,
    regexp: '([\\W]|^)([L,M][\\da-zA-Z]{33})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($network: BitcoinNetwork!, $address: String!) {
        litecoin: bitcoin(network: $network) {
            addressStats(address: {is: $address}){
                address{
                    balance_usd: balance(in: USD)
                    balance: balance
                }
            }
            ins: inputs(inputAddress: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: outputs( outputAddress: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }`,
    checkAddress:
        'ltc1pxc4vpfjtw826kz485yw4872mjl6rarsdjp452tky3qkvqd25zz9qpqa26w',
}
export { litecoin }
